import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const StyledEmailTemplate = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "email-template-wrapper",
})`
  position: relative;
  display: flex;
  width: calc(100% + 48px);

  .emailField {
    display: flex;
    width: calc(100% - 48px);
  }

  .emailFieldInner {
    width: 100%;
  }

  .emailIcon {
    transform: translateY(60%);
    margin-inline-start: 16px;
    cursor: pointer;

    &.emailIconActive {
      color: ${rydeColors.steel};
    }

    &.emailIconDisabled {
      color: ${rydeColors.grey};
    }
  }
`;
